module.exports = __webpack_public_path__ + "img/IMG_8270.1c89103b.jpg";